import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { FINGERPRINT_COOKIE_NAME } from '~/config/fingerprint'
import { encryptSHA256 } from '~/utils/encryption'

/**
 * Gets or generates a device fingerprint.
 * Returns existing fingerprint from cookie, or generates and stores a new one.
 *
 * @param {Object} $cookies - Cookie instance from Nuxt context
 * @param {Object} $sentry - Sentry instance from Nuxt context
 * @returns {Promise<string|null>} - The fingerprint hash or null if generation
 *   fails
 */
export async function getDeviceFingerprint($cookies, $sentry) {
  // Skip if not on client side
  if (process.server || typeof window === 'undefined') {
    return null
  }

  // Return existing fingerprint if available
  const existingFingerprint = $cookies?.get(FINGERPRINT_COOKIE_NAME)
  if (existingFingerprint) {
    return existingFingerprint
  }

  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()

    if (result?.visitorId) {
      const hashedId = await encryptSHA256(result.visitorId)
      $cookies.set(FINGERPRINT_COOKIE_NAME, hashedId, {
        domain: '.importgenius.com',
        path: '/',
        maxAge: 60 * 60 * 24 * 30 // 30 days
      })
      return hashedId
    }
  } catch (error) {
    // Capture the exception in Sentry but do not block the application
    if ($sentry) {
      $sentry.captureException(error)
    }
  }

  return null
}
